import React from "react";
import {useTranslation} from "react-i18next";
import {UiCarousel, UiCarouselImageAndTextType} from "../../ui-components/carousel/UiCarousel";


export const LoginCarousel: React.FC = () => {
    const {t} = useTranslation();
    
    const [imagesAndTexts, _] = React.useState<UiCarouselImageAndTextType[]>(
        [
            {
                imageUrl: "/images/login-carousel-leaderboard.png",
                title: t("login.climb-the-leaderboard"),
                text: t("login.create-account-to-save-stats"),
            },
            {
                imageUrl: "/images/login-carousel-stats.png",
                title: t("login.create-account-to-follow-stats"),
                text: t("login.follow-stats-and-best-score-over-time"),
            },
            {
                imageUrl: "/images/login-carousel-add-friends.png",
                title: t("login.add-friends"),
                text: t("login.add-friends-and-track-their-progress"),
            }
        ]
    );
    
    
    return (
        <div className="h-full flex justify-center items-center">
            <UiCarousel
                imagesAndTexts={imagesAndTexts}
            />
        </div>
    )
}
